<template>
  <illustration-layout :cclink="cclink">
    <div style="padding:35px">
      <div style="text-align:center;border-bottom:1px solid #7a7157">
        <img :src="$assetUrl('scrapbook.png')" alt="Scrapbook" />
        <div style="color:#6d6d64;font-size:38px;letter-spacing:-1px;margin-bottom:30px">
          Interview with an Illustrator
        </div>
        <div>
          <a :href="$host + '/artists/' + item.portfolio_url + ntlink"><img :src="getImageUrl('allabout.jpg')" alt="about" style="display:block" /></a>
          <div style="background-color:#ce0e2d;color:#ffffff;font-size:40px;padding:10px 0">
            {{ item.formatted_name }}
          </div>
        </div>
        <div style="margin:24px 0">
          <a :href="$host + '/artists/' + item.portfolio_url + ntlink"><img :src="getImageUrl('portfolio1.jpg')" alt="about" style="display:block" /></a>
        </div>
        <div style="margin-bottom:24px">
          <a style="padding:5px 12px;color:#fff;text-decoration:none;background-color:#ce0e2d;border-radius:6px" 
            :href="$host + '/artists/' + item.portfolio_url + ntlink">view {{ firstName }}'s portfolio</a>
        </div>
        <div v-html="formattedIntro" style="font-size:19px;line-height:28px;text-align:center"></div>
        <div style="margin:24px 0">
          <a :href="$host + '/artists/' + item.portfolio_url + ntlink"><img :src="getImageUrl('portfolio2.jpg')" alt="about" style="display:block" /></a>
        </div>
        <div style="margin-bottom:24px">
          <a style="padding:5px 12px;color:#fff;text-decoration:none;background-color:#ce0e2d;border-radius:6px" 
            :href="$host + '/artists/' + item.portfolio_url + ntlink">view {{ firstName }}'s portfolio</a>
        </div>
        <div v-html="interview" style="font-size:19px;line-height:28px;text-align:center"></div>
        <div style="margin:24px 0">
          <a :href="$host + '/artists/' + item.portfolio_url + ntlink"><img :src="getImageUrl('interview1.jpg')" alt="about" style="display:block" /></a>
        </div>
        <div style="margin-bottom:24px">
          <a style="padding:5px 12px;color:#fff;text-decoration:none;background-color:#ce0e2d;border-radius:6px" 
            :href="$host + '/artists/' + item.portfolio_url + ntlink">view {{ firstName }}'s portfolio</a>
        </div>
      </div>  
    </div>
  </illustration-layout>
</template>

<script>
import IllustrationLayout from '../layouts/IllustrationLayout.vue'
export default {
  components: {
    IllustrationLayout
  },
  props: {
    id: String
  },
  data () {
    return {
      item: {},
      formattedIntro: '',
      interview: '',
      cclink: this.$store.state.cclink + 'SCRAPBOOK'
    }
  },
  created () {
    if(this.id) {
      this.loadData()
    }
  },
  computed: {
    firstName () {
      if(this.item) {
        return this.item.formatted_name.split(' ').slice(0, 1)[0]
      }
      return ''
    },
    ntlink () {
      let ntlink = this.cclink
      if(this.item) {
        if(this.item.formatted_name) {
          ntlink = this.cclink + '&utm_content=' + encodeURIComponent(this.item.formatted_name)
        }
      }
      return ntlink
    }
  },
  methods: {
    async loadData() {
      let res = await this.$apix.get(`collections/scrapbook/${this.id}`)
      
      this.formattedIntro = this.formatLines(res.data.intro)
      this.interview = this.formatLines(res.data.interview)
      this.item = res.data
    },
    
    formatLines(text){
      let lines = text.split('\n')
      let nf = []
      for(let i = 0; i < lines.length; i++) {
        if(i % 2 === 0) {
          nf.push('<span style="color:#ce0e2d;text-transform:uppercase">' + lines[i] + '</span>')
        }
        else {
          nf.push(lines[i])
        }
      }
      return nf.join('\n')
    },
    getImageUrl(name) {
      return `${this.$imagehost}/images/scrapbook/${this.item.posted}/${name}`
    }
  }
}
</script>

<style>

</style>